import * as React from 'react';
import cx from 'classnames';

import { CompanyLogo, EASTER_LOGOS_LIST } from '../CompanyLogo/CompanyLogo';

import * as cs from './HeaderLogo.module.css';

const HeaderLogo = () => {
  const getRandomEasterLogo = () =>
    EASTER_LOGOS_LIST[Math.floor(Math.random() * EASTER_LOGOS_LIST.length)];

  const [easterLogoShown, setEasterLogoShown] = React.useState(false);
  const [easterLogo, setEasterLogo] = React.useState<string | null>(null);

  // SSR-friendly way to initialize first random easter logo
  React.useEffect(() => {
    if (easterLogo === null) {
      setEasterLogo(getRandomEasterLogo());
    }
  }, [easterLogo]);

  const handleMouseEnter = () => {
    if (!easterLogoShown) {
      setEasterLogo(getRandomEasterLogo());
      setEasterLogoShown(true);
    }
  };

  const handleMouseLeave = () => {
    setEasterLogoShown(false);
  };

  return (
    <div
      className={cx(cs.root, { [cs.easterShown]: easterLogoShown })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CompanyLogo className={cx(cs.logo, cs.regular)} type="default" />
      <CompanyLogo
        className={cx(cs.logo, cs.regular, cs.letters)}
        type="letters"
      />
      <CompanyLogo className={cx(cs.logo, cs.monochrome)} type="monochrome" />
      {easterLogo && (
        <CompanyLogo
          className={cx(cs.logo, cs.easter, cs[easterLogo])}
          type={easterLogo}
        />
      )}
    </div>
  );
};

export { HeaderLogo };
